import { Tag, TagLabel, Wrap, WrapItem } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useCpvCodes } from "../../../../../../common/cpv/useCpvCodes";

export const CpvCodeTags = ({ codes }: { codes: string[] }) => {
  const { i18n } = useTranslation();
  const { codeIndex } = useCpvCodes();
  const isNorwegian = i18n.language.startsWith("no");
  return (
    <Wrap spacing="2">
      {codes.map((code) => {
        const dto = codeIndex[code];
        const label = dto ? (isNorwegian ? dto.nameNb : dto.nameEn) : null;
        return (
          <WrapItem key={code}>
            <Tag colorScheme="teal" variant="subtle" size="md" maxW="100%">
              <TagLabel whiteSpace="normal">
                {code}
                {label ? ` — ${label}` : ""}
              </TagLabel>
            </Tag>
          </WrapItem>
        );
      })}
    </Wrap>
  );
};
